import React from "react";
import { ScrollText } from "lucide-react";
import CrudModule from "@/components/CrudModule";

export default function Licenses() {
  return (
    <CrudModule
      title="Controle de Licenças Ambientais"
      subtitle="CETESB, AVCB, CADRI e outras — com responsável e fluxo de renovação"
      icon={ScrollText}
      endpoint="licenses"
      exportKey="licenses"
      testid="licenses"
      columns={[
        { key: "valid_until", label: "Validade", badge: "validity" },
        { key: "lic_type", label: "Tipo" },
        { key: "name", label: "Licença" },
        { key: "number", label: "Número" },
        { key: "responsible", label: "Responsável" },
        { key: "renewal_status", label: "Renovação", badge: true },
        { key: "doc", label: "Arquivo", file: true, idKey: "document_id" },
      ]}
      fields={[
        { name: "name", label: "Nome / identificação da licença", type: "text", required: true, full: true },
        { name: "lic_type", label: "Tipo", type: "select", options: ["CETESB", "AVCB", "CADRI", "CTF / IBAMA", "Alvará", "Outorga de Água", "Outra"], default: "CETESB" },
        { name: "number", label: "Número / protocolo", type: "text" },
        { name: "issue_date", label: "Data de emissão", type: "date" },
        { name: "valid_until", label: "Validade", type: "date" },
        { name: "responsible", label: "Responsável pela renovação", type: "text" },
        { name: "renewal_status", label: "Status de renovação", type: "select", options: ["Em dia", "Em renovação", "Vencida"], default: "Em dia" },
        { name: "renewal_started", label: "Renovação iniciada em", type: "date" },
        { name: "notes", label: "Observações", type: "textarea", full: true },
        { name: "document", label: "Documento da licença (upload)", type: "file", idKey: "document_id", nameKey: "document_name", full: true },
      ]}
    />
  );
}
